export default __webpack_public_path__ + "static/media/smallWhiteLogoSimer.d0ce837f.svg";